export const META: Record<string, { title: string; description: string }> = {
  "/": {
    title: "Scorio — Judge, broadcast and publish competition",
    description:
      "Browser judging, OBS overlays and public results for wakeboard, wakesurf and cable events. Two small competitions a year free. Try the read-only demo.",
  },
  "/pricing": {
    title: "Scorio Pricing — Free, Event pass, Club Unlimited and Tour",
    description:
      "Free: two events a year up to 50 entries. Event pass from USD 49. Club Unlimited USD 99/month or 790/year. Paid plans not yet on sale; Tour planned.",
  },
  "/results/demo": {
    title: "Scorio Demo — Live public competition results",
    description:
      "Try Scorio without an account. A read-only club-day demo with fictional riders, illustrative scores and the real public results service.",
  },
  "/terms": {
    title: "Terms of service — Scorio",
    description:
      "Scorio terms of service publication status and contact details. Paid plans are not on sale.",
  },
  "/privacy": {
    title: "Privacy policy — Scorio",
    description: "Scorio privacy policy publication status and contact details.",
  },
  "/refunds": {
    title: "Refund terms — Scorio",
    description: "Scorio refund terms publication status and support contact details.",
  },
};
